import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Verification.css';
import LoadingOverlay from '../../General/LoadingOverlay';
const Verification = ({
    companyInfo,
    nextStep,
    prevStep,
    name,
    hasSim,
    organizationPhoneNumber,
    plan,
    paymentCyctle,
    forwardingPhoneNumber,
  }) => {
    const [enteredCode, setEnteredCode] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // ⬅️ Start with true
    const [codeExpiresAt, setCodeExpiresAt] = useState(null);
    const [timeLeft, setTimeLeft] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
  
    const planPrices = {
      Basic: 199,
      Premium: 399,
      Enterprise: 1199,
    };
  
    useEffect(() => {
      sendVerificationCode();
    }, []);
  
    useEffect(() => {
      if (!codeExpiresAt) return;
      const interval = setInterval(() => {
        const diff = Math.floor((codeExpiresAt - new Date()) / 1000);
        setTimeLeft(Math.max(diff, 0));
      }, 1000);
      return () => clearInterval(interval);
    }, [codeExpiresAt]);
  
    const sendVerificationCode = async () => {
      try {
        setIsLoading(true);
        const newPlan = translatePlanName(plan) + '_' + paymentCyctle;
        const response = await axios.post('https://gambot.azurewebsites.net/api/Webhooks/SendVerificationCode', {
          phoneNumber: companyInfo.contactPhoneNumber,
          email: companyInfo.contactEmail,
          name,
          companyName: companyInfo?.companyName,
          organizationName: companyInfo?.organizationName,
          companyIdNumber: companyInfo?.idNumber,
          hasSim,
          url: companyInfo?.companyUrl,
          simNumber: organizationPhoneNumber,
          plan,
          paymentCyctle,
          productKey: newPlan,
        });
  
        setVerificationCode(response.data?.Data?.toString() || '');
        setCodeExpiresAt(new Date(Date.now() + 3 * 60 * 1000));
        setEnteredCode('');
        setIsVerified(false);
      } catch (error) {
        console.error('Error sending verification code:', error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const translatePlanName = (planName) => {
      switch (planName) {
        case 'בסיס': return 'Basic';
        case 'פרימיום': return 'Premium';
        case 'ארגונים': return 'Enterprise';
        default: return planName;
      }
    };
  
    const formatTime = (seconds) => {
      const min = Math.floor(seconds / 60);
      const sec = seconds % 60;
      return `${min}:${sec < 10 ? '0' : ''}${sec}`;
    };
  
    const handleVerification = () => {
      if (timeLeft <= 0) {
        alert('הקוד פג תוקף. שלח קוד חדש.');
        return;
      }
  
      if (enteredCode.trim() === verificationCode.trim()) {
        setIsVerified(true);
        handleNextStep(); // ⬅️ CALLING THE REAL NEXT STEP
    } else {
        alert('הקוד שהזנת שגוי');
      }
    };
  
    const handleNextStep = async () => {
      try {
        setIsLoading(true);
        const basePlanPrice = planPrices[translatePlanName(plan)] || 0;
        const yearlyPrice = Math.floor(basePlanPrice * 0.9) * 12;
        const calculatedPlanPrice = paymentCyctle === 'yearly' ? yearlyPrice : basePlanPrice;
  
        const data = {
          plan: translatePlanName(plan),
          forwardingPhoneNumber,
          totalAmount,
          payEach: paymentCyctle,
          planPrice: calculatedPlanPrice,
          customerEmail: companyInfo.contactEmail,
          companyInfo: {
            companyName: companyInfo.companyName,
            organizationName: companyInfo.organizationName,
            companyUrl: companyInfo.companyUrl,
            companyPhoneNumber: companyInfo.contactPhoneNumber,
            companyId: companyInfo.idNumber,
            timezone: companyInfo.timezone,
          },
          contactInfo: {
            contactFullName: companyInfo.contactFullName,
            contactEmail: companyInfo.contactEmail,
            contactPhoneNumber: companyInfo.contactPhoneNumber,
          },
          simInfo: {
            hasSim,
            selectedSimNumber: !hasSim ? organizationPhoneNumber.replace('+', '') : '',
            simNumberEntered: organizationPhoneNumber.replace('+', ''),
          },
        };
  
        const response = await axios.post(
          'https://gambot.azurewebsites.net/api/Webhooks/createNewTrialSubscription',
          data
        );
  
        if (response.status === 200) {
          nextStep();
        } else {
          alert('אירעה שגיאה בעת יצירת המנוי');
        }
      } catch (error) {
        alert(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
      <>
        <LoadingOverlay loading={isLoading} />
        <div className="verification-container">
          <h2>אימות פרטים</h2>
          <p>.אנא הזן את הקוד שקיבלת בהודעת וואטסאפ ובמייל</p>
          <input
            type="text"
            value={enteredCode}
            onChange={(e) => setEnteredCode(e.target.value)}
            placeholder="הזן קוד אימות"
            className="verification-input-code"
          />
          <div className="timer-text">
            {timeLeft > 0 ? (
              <span>הקוד בתוקף לעוד {formatTime(timeLeft)} דקות</span>
            ) : (
              <span style={{ color: 'red' }}>פג תוקף הקוד</span>
            )}
          </div>
          <p className="verification-resend-text">
  לא קיבלת קוד?{' '}
  <span onClick={sendVerificationCode} className={`verification-resend-link ${isLoading ? 'disabled' : ''}`}>
    שלח קוד שוב
  </span>
</p>
          
          {/* <button className="verification-send-code" onClick={sendVerificationCode} disabled={isLoading}>
            שלח קוד מחדש
          </button> */}
          <div className="payment-container-button-verification-container">

  <button className="verification-submit-inline" onClick={handleVerification} disabled={isLoading || timeLeft <= 0}>
    אמת והמשך
  </button>
  <button className="payment-container-prev-button-verification" onClick={prevStep}>
    הקודם
  </button>
</div>
        </div>
      </>
    );
  };
  
  export default Verification;